export default __webpack_public_path__ + "static/ir-12e7432b428f8d631eb5fede40b2e095.svg";